/**
 * Pick the preview string for a conversation row. If a thread is older
 * than 1h and the backend has a rollup ``summary``, show that; otherwise
 * show the raw last-message ``preview`` so recent threads stay literal.
 */
const ONE_HOUR_MS = 60 * 60 * 1000;

export interface PreviewTextInput {
  /** Backend-generated rollup; not populated yet. */
  summary?: string | null;
  /** Last-message excerpt from ``PeersonaThreadSummary``. */
  preview?: string | null;
  lastMessageAt?: string | null;
  /** Override for deterministic tests. */
  now?: number;
}

export function pickPreviewText({ summary, preview, lastMessageAt, now }: PreviewTextInput): string {
  const trimmedSummary = (summary ?? '').trim();
  const trimmedPreview = (preview ?? '').trim();

  if (trimmedSummary && lastMessageAt) {
    const ts = new Date(lastMessageAt).getTime();
    const reference = now ?? Date.now();
    if (Number.isFinite(ts) && reference - ts > ONE_HOUR_MS) {
      return trimmedSummary;
    }
  }

  return trimmedPreview;
}
